import { CREATED_AT, UID } from 'shared/api/query/constants';
import { provisionedGroup as provisionedGroupConfig, provisionedNames as provisionedNamesConfig, provisionedResource as provisionedResourceConfig, provisionedUser as provisionedUserConfig } from 'shared/api/query/configs.json';

export const provisionedGroupChildren = [
  { attr: UID },
  { attr: provisionedGroupConfig.edges.displayName },
];

export const provisionedUserChildren = [
  { attr: UID },
  { attr: CREATED_AT },
  { attr: provisionedUserConfig.edges.deactivatedAt, default: null },
  { attr: provisionedUserConfig.edges.active, default: null },
  { attr: provisionedUserConfig.edges.provisioningError, default: null },
  { attr: provisionedUserConfig.edges.externalId },
  {
    attr: provisionedUserConfig.edges.name,
    model: provisionedNamesConfig.model,
    default: { familyName: '', givenName: '' },
    children: [
      { attr: UID },
      { attr: provisionedNamesConfig.edges.familyName },
      { attr: provisionedNamesConfig.edges.givenName },
    ],
  },
  {
    attr: provisionedUserConfig.edges.emails,
    model: provisionedResourceConfig.model,
    children: [
      { attr: UID },
      { attr: provisionedResourceConfig.edges.value },
    ],
    default: [{ value: '' }],
  },
];
